import "./scss/mdb.free.scss";
import "./scss/mdb.core.scss";
import "./App.css";
import CarouselHomepage from "./CarouselHomepage";
import logo from "./assets/logo/png/logo-color.png";
import { RequireAuth } from "./authentication/RequireAuth";
import { Login } from "./authentication/Login";
import React, { useState } from "react";
import {
  BrowserRouter,
  Route,
  Routes,
  Link,
  useLocation,
} from "react-router-dom"; // Import Routes instead of Switch

import Cars from "./vehicles/Cars"; // The component for cars page
import Bikes from "./vehicles/Bikes";
import Trucks from "./vehicles/Trucks";
import Ships from "./vehicles/Ships";
import Trains from "./vehicles/Trains";
import Planes from "./vehicles/Planes";
import AddVehicle from "./AddVehicle";
import {
  MDBContainer,
  MDBNavbar,
  MDBNavbarToggler,
  MDBIcon,
  MDBNavbarNav,
  MDBNavbarItem,
  MDBBtn,
  MDBCollapse,
  MDBFooter,
} from "mdb-react-ui-kit";
import {
  FaLinkedin,
  FaCar,
  FaTruck,
  FaMotorcycle,
  FaPlane,
  FaTrain,
  FaShip,
  FaBolt,
  FaSignInAlt,
  FaSignOutAlt,
  FaMinusCircle,
  FaBars
} from "react-icons/fa";
// import { Tooltip as ReactTooltip } from "react-tooltip";
import { Tooltip as ReactTooltip } from "react-tooltip";

import { Outlet, useNavigate } from "react-router-dom";
import {
  Authenticator,
  useAuthenticator,
  Button,
  Heading,
  View,
} from "@aws-amplify/ui-react";

export default function App() {
  const [showBasic, setShowBasic] = useState(false);
  // const location = useLocation();
  const currentPathname = window.location.pathname;

  const { route, signOut } = useAuthenticator((context) => [
    context.route,
    context.signOut,
  ]);

  const [isOpen, setIsOpen] = useState(false);
  const [showDisclaimer, setShowDisclaimer] = useState(true);

  function logOut() {
    signOut();
    window.location.href = "/login"; // Directly change the URL
  }

  // background videos for different pages
  const videoSrc = {
    homepage:
      "https://vehicle-wiki-video-assets-bucket.s3.amazonaws.com/whiteBackground.mp4",
    cars: "https://vehicle-wiki-video-assets-bucket.s3.amazonaws.com/cars.mp4",
    trains:
      "https://vehicle-wiki-video-assets-bucket.s3.amazonaws.com/trains.mp4",
    bikes:
      "https://vehicle-wiki-video-assets-bucket.s3.amazonaws.com/bikes.mp4",
    Trucks:
      "https://vehicle-wiki-video-assets-bucket.s3.amazonaws.com/trucks.mp4",
    Planes:
      "https://vehicle-wiki-video-assets-bucket.s3.amazonaws.com/planes.mp4",
    Ships:
      "https://vehicle-wiki-video-assets-bucket.s3.amazonaws.com/sailing.mp4",
  };

  return (
    <>
      {/*  This div is to allow for page traversing between categories */}
      <BrowserRouter>
        <div>
          {/* Navbar at the top */}
          <MDBNavbar expand="lg" light bgColor="light">
            <MDBContainer fluid>

              <a href="/" className="nav-link">
                <img
                  src={logo}
                  alt="VEHiCLE-WiKi"
                  width="50"
                  height="50"
                />
              </a>

              <MDBNavbarToggler
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                onClick={() => setIsOpen(!isOpen)}
              >
                <FaBars />
              </MDBNavbarToggler>


              <MDBCollapse navbar show={isOpen} >
                <MDBNavbarNav className={`mr-auto mb-2 mb-lg-0 d-flex ${isOpen ? "vertical-nav" : ""}`}>

                  <MDBNavbarItem>
                    <a href="/cars" className="nav-link ">
                      <FaCar /> CARS
                    </a>
                  </MDBNavbarItem>

                  <MDBNavbarItem>
                    <a href="/trucks" className="nav-link">
                      <FaTruck /> TRUCKS
                    </a>
                  </MDBNavbarItem>

                  <MDBNavbarItem>
                    <a href="/bikes" className="nav-link">
                      <FaMotorcycle /> MOTORCYCLES
                    </a>
                  </MDBNavbarItem>

                  <MDBNavbarItem>
                    <a href="/planes" className="nav-link">
                      <FaPlane /> PLANES
                    </a>
                  </MDBNavbarItem>

                  <MDBNavbarItem>
                    <a href="/trains" className="nav-link">
                      <FaTrain /> TRAINS
                    </a>
                  </MDBNavbarItem>

                  <MDBNavbarItem>
                    <a href="/ships" className="nav-link">
                      <FaShip />
                      SHIPS
                    </a>
                  </MDBNavbarItem>

                  <div
                    className="d-flex  align-items-center  justify-content-end"
                    style={{ marginLeft: "auto" }}
                  >
                    <MDBNavbarItem className="nav-link ">
                      <a
                        href="/add-vehicle"
                        className="nav-link align-items-center "
                      >
                        {/* Ternary operator to determine the displayed icon */}
                        {route !== "authenticated" ? (
                          // Display a sign-in icon and redirect to login page on onClick
                          <FaSignInAlt
                            onClick={() => (window.location.href = "/login")}
                          />
                        ) : (
                          // Display a minus circle icon and attach logOut() function to onClick
                          <FaMinusCircle onClick={() => logOut()} />
                        )}
                        {/* {' '}
                    &nbsp; */}
                      </a>
                    </MDBNavbarItem>
                  </div>
                </MDBNavbarNav>

              </MDBCollapse>
            </MDBContainer>
          </MDBNavbar>
          <Routes>
            {" "}
            {/* Use Routes to switch between pages */}
            <Route
              path="/cars"
              element={
                <div>
                  {window.location.pathname === "/cars" && (
                    <video
                      className="homepageVideo"
                      autoPlay
                      muted
                      loop
                      playsInline
                    >
                      <source src={videoSrc["cars"]} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}
                  <Cars />
                </div>
              }
            />
            <Route
              path="/bikes"
              element={
                <div>
                  {window.location.pathname === "/bikes" && (
                    <video
                      className="homepageVideo"
                      autoPlay
                      muted
                      loop
                      playsInline
                    >
                      <source src={videoSrc["bikes"]} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}
                  <Bikes />
                </div>
              }
            />
            <Route
              path="/trucks"
              element={
                <div>
                  {window.location.pathname === "/trucks" && (
                    <video
                      className="homepageVideo"
                      autoPlay
                      muted
                      loop
                      playsInline
                    >
                      <source src={videoSrc["Trucks"]} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}
                  <Trucks />
                </div>
              }
            />
            <Route
              path="/planes"
              element={
                <div>
                  {window.location.pathname === "/planes" && (
                    <video
                      className="homepageVideo"
                      autoPlay
                      muted
                      loop
                      playsInline
                    >
                      <source src={videoSrc["Planes"]} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}
                  <Planes />
                </div>
              }
            />
            <Route
              path="/trains"
              element={
                <div>
                  {/* Video background for trucks */}
                  {window.location.pathname === "/trains" && (
                    <video
                      className="homepageVideo"
                      autoPlay
                      muted
                      loop
                      playsInline
                    >
                      <source src={videoSrc["trains"]} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}
                  {/* Render the Trucks component */}
                  <Trains />
                </div>
              }
            />
            <Route
              path="/ships"
              element={
                <div>
                  {/* Video background for trucks */}
                  {window.location.pathname === "/ships" && (
                    <video
                      className="homepageVideo"
                      autoPlay
                      muted
                      loop
                      playsInline
                    >
                      <source src={videoSrc["Ships"]} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}
                  {/* Render the Trucks component */}
                  <Ships />
                </div>
              }
            />
            <Route
              path="/add-vehicle"
              element={
                <RequireAuth>
                  <AddVehicle />
                </RequireAuth>
              }
            />
            <Route path="/login" element={<Login />} />
            {/* Define your homepage content here */}
            <Route
              path="/"
              element={
                <div>
                  {/* <Homepage /> */}
                  {/* Video background */}
                  {window.location.pathname === "/" && (
                    <video
                      className="homepageVideo"
                      autoPlay
                      muted
                      loop
                      playsInline
                    >
                      <source src={videoSrc["homepage"]} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}

                  <CarouselHomepage />

                  {window.location.pathname === "/cars" && (
                    <video
                      className="homepageVideo"
                      autoPlay
                      muted
                      loop
                      playsInline
                    >
                      <source src={videoSrc["cars"]} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}

                  {window.location.pathname === "/trains" && (
                    <video
                      className="homepageVideo"
                      autoPlay
                      muted
                      loop
                      playsInline
                    >
                      <source src={videoSrc["trains"]} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}

                  {window.location.pathname === "/bikes" && (
                    <video
                      className="homepageVideo"
                      autoPlay
                      muted
                      loop
                      playsInline
                    >
                      <source src={videoSrc["bikes"]} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}

                  {window.location.pathname === "/trucks" && (
                    <video
                      className="homepageVideo"
                      autoPlay
                      muted
                      loop
                      playsInline
                    >
                      <source src={videoSrc["trucks"]} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}

                  {window.location.pathname === "/planes" && (
                    <video
                      className="homepageVideo"
                      autoPlay
                      muted
                      loop
                      playsInline
                    >
                      <source src={videoSrc["planes"]} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}

                  {window.location.pathname === "/ships" && (
                    <video
                      className="homepageVideo"
                      autoPlay
                      muted
                      loop
                      playsInline
                    >
                      <source src={videoSrc["ships"]} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  )}
                </div>
              }
            />
          </Routes>
        </div>

        <div>
          {/* Footer */}
          <MDBFooter
            className="text-center text-white"
            style={{
              backgroundColor: "#f1f1f1",
              position: "fixed",
              bottom: 0,
              width: "100%",
            }}
          >
            <MDBContainer className="pt-1">
              <section className="mb-0 text-center text-dark p-0">
                {showDisclaimer && (
                  <div
                    style={{
                      display: 'flex',            // Use flexbox for layout
                      justifyContent: 'space-between', // Space elements out to fill the container
                      alignItems: 'center',       // Vertically center the items
                      padding: '2px 0'           // Vertical padding (top & bottom) of 5px, no horizontal padding
                    }}
                  >
                    <p style={{
                      textAlign: "center",
                      margin: "0",                          // Removed vertical margin
                      fontSize: "12px",
                      color: "gray",
                      flex: 1,
                      lineHeight: "14px"                   // Adjust line height
                    }}>
                      We do not own the rights to the images or videos on this site. They are used solely for illustrative purposes and are intended as placeholders. Images were taken from Google Images and other royalty-free sources.
                    </p>

                    <div
                      style={{
                        cursor: 'pointer',
                        // padding: '5px',
                        marginLeft: 'auto',
                        color: "black",
                      }}
                      onClick={() => setShowDisclaimer(false)} // Set the state to false when "X" is clicked
                    >
                      X
                    </div>
                  </div>
                )}


                <ReactTooltip id="chris" place="top" effect="solid">
                  Christophe's Linkedin
                </ReactTooltip>
              </section>
            </MDBContainer>

            <div
              className="text-center text-dark p-1"
              style={{
                backgroundColor: "rgba(0, 0, 0, 0.1)",
                fontSize: "12px",
                color: "gray",
                display: 'flex',            // Enable flexbox
                alignItems: 'center',       // Vertically align content to the middle
                justifyContent: 'center'    // Center the content both vertically and horizontally 
              }}
            >
              © 2023 Copyright Mark Emmanuel
              <a
                className="custom-linkedin-btn"
                href="https://www.linkedin.com/in/mark-emmanuel-98b7aab3/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '19px',
                  height: '19px',
                  borderRadius: '50%',
                  backgroundColor: 'white',
                  margin: '0 5px',
                  color: 'blue',
                  textDecoration: 'none'
                }}
              >
                <FaLinkedin
                  style={{
                    fontSize: "20px",
                    color: "blue",
                  }}
                />

              </a>, Christophe Manzi
              <a
                className="custom-linkedin-btn"
                href="https://www.linkedin.com/in/christophe-manzi/"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '19px',
                  height: '19px',
                  borderRadius: '50%',
                  backgroundColor: 'white',
                  margin: '0 5px',
                  color: 'blue',
                  textDecoration: 'none'
                }}
              >
                <FaLinkedin
                  style={{
                    fontSize: "20px",
                    color: "blue",
                  }}
                />
              </a>
            </div>
          </MDBFooter>
        </div >
      </BrowserRouter >
    </>
  );
}
